import Link from '@components/ui/link'
import { useTranslation } from 'react-i18next'

interface ErrorMessageProps {
  reportLink: string
  onlyError?: boolean
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  reportLink,
  onlyError,
}) => {
  const { t: translate } = useTranslation('quickorder')
  const message = !onlyError
    ? translate('text-partial-item-added-error')
    : translate('text-item-added-error')

  return (
    <div className="border border-brand-danger rounded p-5 m-5 ">
      <p className="text-brand-dark text-center text-sm">
        {message}{' '}
        <Link href={reportLink} className="text-brand underline font-semibold ">
          {translate('text-download-error-report')}
        </Link>
      </p>
    </div>
  )
}

export default ErrorMessage
